"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertToMMDDYYYY = convertToMMDDYYYY;
exports.reverseDate = void 0;
var _split2 = _interopRequireDefault(require("lodash/split"));
var _dateFns = require("date-fns");
var _date = require("../constants/date.constants");
/**
 * Reverse DD-MM-YYYY to YYYY-MM-DD
 * @param date
 * @returns {string}
 */
var reverseDate = exports.reverseDate = function reverseDate() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return (0, _split2["default"])(date, '-').reverse().join('-');
};

/**
 * convertToDate mm/dd/yyyy
 * @param {String} ddmmyyyy
 * @returns {Object} date Object
 */
function convertToMMDDYYYY() {
  var ddmmyyyy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var date = (0, _dateFns.parse)(ddmmyyyy, _date.DATE_FORMATS.YYYY_MM_DD, new Date());
  return (0, _dateFns.format)(date, _date.DATE_FORMATS.MMDDYYYY);
}